import { EmvKernelProfileDtoToEntity } from "src/app/features/EmvKernelProfile/services/mappers/EmvKernelProfileDtoToEntity";
import type { EmvKernelProfileDto } from "src/app/features/EmvKernelProfile/types/EmvKernelProfileDto";
import type { EmvKernelProfileEntity } from "src/app/features/EmvKernelProfile/types/EmvKernelProfileEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const EmvKernelProfileTableDtoMapper = (
    input: Readonly<ResourcePageDto<EmvKernelProfileDto>>,
): ResourcePageEntity<EmvKernelProfileEntity> => {
    return {
        list: input.list ? input.list.map(EmvKernelProfileDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
